<template>
  <div class="flex items-center gap-2 ml-auto">
    <div class="flex gap-2 items-center w-full">
		<!-- <EwMultiSelect
		:inputType="'select'"
		class="text-sm w-64 !py-2px !max-w-64 !m-0"
  		v-model="assistantGuide"
		placeholder="Predefined Guides"
		:options="predefinedGuides"
		optionLabel="title"
		optionValue="identifier"
		:size="'sm'"
		:truncate="true"
		display="chip"
		appendTo="self"
		:disabled="props.disabled"
		/> -->

      <EwInput
        :inputType="'input'"
        v-model="assistantEditorContent"
        placeholder="Please, provide your guide!"
        :propName="'assistantEditorContent'"
        :disabled="props.disabled"
        class="w-full !m-0 min-w-60 text-sm"
	  @keydown.enter.stop.prevent="askAssistant"

      />
    </div>

    <EwButton
      type="danger"
      size="sm"
	  icon="i-fa6-solid:people-arrows"
      class="flex items-center gap-1"
	  :loading="props.loading"
      label="Ask Assistant"
      @click="askAssistant"
    >
      Ask
    </EwButton>
  </div>
</template>


<script setup lang="ts">
import { ref, inject, computed } from 'vue'
import { EwInput, EwMultiSelect, EwButton, EwIcon } from '@arkit/ew-vue-components'
import type { CVResponse } from '@/types'
import { CVDataProvided } from '@/types/cvTypes'
import axios from 'axios'

const userGuide = defineModel<string>('userGuide', { default: '' })


const cvData = inject(CVDataProvided) as Ref<CVResponse>
provide(CVDataProvided, cvData)

const assistantGuide = ref<string[]>([])


const assistantEditorContent = ref('')

// ✅ Merr predefinedGuides nga cvData
const predefinedGuides = computed(() => {
	console.log('cvData.value?.data?.predefinedGuides', cvData.value?.data?.predefinedGuides)
  return cvData.value?.data?.predefinedGuides ?? []
})

const props = withDefaults(
  defineProps<{
    disabled?: boolean
    contentObject?: Record<string, any>
	loading?: boolean

  }>(),
  {
    disabled: false,
    contentObject: () => ({}),
	loading: false

  }
)

const emit = defineEmits<{
  (e: 'ask', payload: { 
	askAssistant:{
	userGuide: string
    // selectedPredefinedGuides?: string | string[]

} }): void
}>()

function askAssistant() {
  if (!assistantEditorContent.value.trim()) {
    return;
  }

  // Emito kërkesën për postim te prindi
  emit('ask', {
    askAssistant: {
    userGuide: assistantEditorContent.value,
  	// selectedPredefinedGuides: assistantGuide.value

    }
  });
}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}

.ew-multiselect-root{
	overflow:unset!important;
}
.ew-multiselect-label.ew-multiselect-truncated{
	padding-top: calc(.4rem - 2px) !important;
	padding-bottom: 0.4rem!important;
}
</style>
